import i18n, { addTranslations } from './i18n';
import { useTranslation, I18nextProvider } from 'react-i18next';
import Collapsible from '../collapsible/Collapsible';

export type RegulatoryProps = {
	materialTypeAndHeader: Array<{ header: string; materialType: string }>;
	regulatoryResults: Array<{
		blkFundId: string;
		fundName: string;
		searchResults: string[];
		documentIdMapBySearchResultKey: Record<string, string>;
		fundTypeLabels: string[];
	}>;
	tickerMapByBlkFundId: Record<string, string>;
	shareClassTranslations: Record<string, string>;
	searchRecordByFundIdShareClass: Record<string, Record<string, string>>;
	iFrameKeyName: string;
	fundLinkByBlkIdShareClass: Record<string, string>;
	siteContext: string;
	sitePath: string;
};

const Regulatory: React.FC<RegulatoryProps> = ({
	materialTypeAndHeader,
	regulatoryResults,
	tickerMapByBlkFundId,
	shareClassTranslations,
	searchRecordByFundIdShareClass,
	iFrameKeyName,
	fundLinkByBlkIdShareClass,
	siteContext,
	sitePath,
}) => {
	addTranslations('en', 'shareClass', shareClassTranslations);

	const { t } = useTranslation('shareClass');

	return (
		<table className="literature-table">
			<tbody>
				{regulatoryResults.map(
					(regulatoryResult: {
						blkFundId: string;
						fundName: string;
						searchResults: string[];
						documentIdMapBySearchResultKey: Record<string, string>;
						fundTypeLabels: string[];
					}) => {
						return regulatoryResult.searchResults.map(
							(searchResultKey: string) => {
								const shareClass: string = t(searchResultKey);
								const fundTicker: string =
									tickerMapByBlkFundId[
										regulatoryResult.blkFundId + '_' + searchResultKey
									];
								const documentId: string =
									regulatoryResult.documentIdMapBySearchResultKey[
										searchResultKey
									] || '';
								const searchRecordMap: Record<string, string> =
									searchRecordByFundIdShareClass[
										regulatoryResult.blkFundId + '_' + searchResultKey
									];
								return (
									<tr
										id={regulatoryResult.blkFundId}
										className="fundRow mobile-only"
										key={fundTicker}
										data-fund-name={regulatoryResult.fundName}
										data-nasdaq-ticker={fundTicker}
										data-fundtype-labels={regulatoryResult.fundTypeLabels}
									>
										<td
											className="row bold-text mobile-row"
											data-fund-id={regulatoryResult.blkFundId}
											data-fund-name={regulatoryResult.fundName}
											data-nasdaq-ticker={fundTicker}
										>
											<Collapsible
												open={false}
												title={regulatoryResult.fundName}
												link={
													fundLinkByBlkIdShareClass[
														regulatoryResult.blkFundId + '_' + searchResultKey
													]
												}
												fundTicker={fundTicker}
												shareClass={shareClass}
												materialTypeAndHeader={materialTypeAndHeader}
												searchRecordMap={searchRecordMap}
												documentId={documentId}
												blkFundId={regulatoryResult.blkFundId}
												searchResultKey={searchResultKey}
												iFrameKeyName={iFrameKeyName}
												siteContext={siteContext}
												sitePath={sitePath}
											/>
										</td>
									</tr>
								);
							}
						);
					}
				)}
			</tbody>
		</table>
	);
};

const GlsRegulatory = (props: RegulatoryProps) => (
	<I18nextProvider i18n={i18n}>
		<Regulatory {...props} />
	</I18nextProvider>
);

export default GlsRegulatory;
